export const BUDGET_STATUS = Object.freeze({
    AWAITING_CONFIRMATION: '1',
    AWAITING_APPROVAL: '2',
    PENDENT: '3',
    APPROVED: '4',
    REJECTED: '5',
    REPPROVED: '6',
    CREATED_ORDER: '7',
    OVERDUE: '9',
    AWAITING_BUDGET_SEND: '10',
    CANCELED: '11'
});